"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pillStyles = exports.Pill = void 0;
var tslib_1 = require("tslib");
var kebabCase_1 = (0, tslib_1.__importDefault)(require("lodash/kebabCase"));
var React = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var test_helpers_1 = require("../../lib/test-helpers");
var colors_1 = require("../../theme/colors");
var flexbox_1 = require("../flexbox");
var padding_1 = require("../padding");
var stack_1 = require("../stack");
var text_1 = require("../text");
var VARIANT_STYLE = {
    dotted: {
        background: 'none',
        border: "2px dashed ".concat(colors_1.colors.brand[400]),
        color: 'active',
        weight: 500,
    },
    solid: {
        background: colors_1.colors.steel[100],
        border: "1px solid ".concat(colors_1.colors.steel[100]),
        color: 'default',
        weight: 600,
    },
};
var SIZE_STYLE = {
    card: {
        justifyContent: 'center',
        padding: '20px 6px',
        width: '100%',
        size: 'regular',
    },
    badge: {
        justifyContent: 'space-between',
        padding: '2px 6px',
        width: 'inherit',
        size: 'small',
    },
};
function Pill(props) {
    var backgroundColor = props.backgroundColor, badge = props.badge, href = props.href, icon = props.icon, onClick = props.onClick, _a = props.size, size = _a === void 0 ? 'badge' : _a, subtitle = props.subtitle, _b = props.target, target = _b === void 0 ? '_blank' : _b, title = props.title, variant = props.variant, propTestId = props.testId;
    var testId = propTestId !== null && propTestId !== void 0 ? propTestId : (0, test_helpers_1.generateTestId)((0, kebabCase_1.default)(title), 'pill');
    return (React.createElement(StyledPill, { href: href, target: target, onClick: onClick, variant: variant, size: size, backgroundColor: backgroundColor, "data-testid": testId },
        React.createElement(flexbox_1.Flexbox, { flexDirection: "row", alignItems: "center", justifyContent: SIZE_STYLE[size].justifyContent },
            React.createElement(stack_1.Stack, { direction: "horizontal", gap: 8, alignItems: "center" },
                icon ? React.createElement(React.Fragment, null, icon) : null,
                React.createElement(text_1.Text, { color: VARIANT_STYLE[variant].color, weight: VARIANT_STYLE[variant].weight, size: SIZE_STYLE[size].size, nowrap: true }, title),
                subtitle ? (React.createElement(text_1.Text, { color: "light", size: SIZE_STYLE[size].size, nowrap: true, truncate: true }, subtitle)) : null),
            badge ? React.createElement(padding_1.Padding, { left: 8 }, badge) : null)));
}
exports.Pill = Pill;
var pillStyles = function (variant, size, backgroundColor) { return "\n  background-color: ".concat(backgroundColor || VARIANT_STYLE[variant].background, ";\n  border-radius: 3px;\n  border: ").concat(VARIANT_STYLE[variant].border, ";\n  display: inline-block;\n  padding: ").concat(SIZE_STYLE[size].padding, ";\n  text-decoration: none;\n  width: ").concat(SIZE_STYLE[size].width, ";\n  box-sizing: border-box;\n"); };
exports.pillStyles = pillStyles;
var StyledPill = styled_components_1.default.a(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  ", "\n  &:hover {\n    cursor: ", ";\n  }\n"], ["\n  ", "\n  &:hover {\n    cursor: ", ";\n  }\n"])), function (_a) {
    var variant = _a.variant, size = _a.size, backgroundColor = _a.backgroundColor;
    return (0, exports.pillStyles)(variant, size, backgroundColor);
}, function (_a) {
    var onClick = _a.onClick, href = _a.href;
    return (onClick || href ? 'pointer' : 'default');
});
var templateObject_1;
//# sourceMappingURL=index.js.map